/**
 * Spanish box-plot prompts and data titles (ADR 0099 §3). Same shape and the
 * same numbers as the English file.
 */
export const boxPlotPrompts = {
    median: () => `¿Cuál es la mediana?`,
    lowerQuartile: () => `¿Cuál es el cuartil inferior?`,
    upperQuartile: () => `¿Cuál es el cuartil superior?`,
    range: () => `¿Cuál es el rango?`,
    interquartileRange: () => `¿Cuál es el rango intercuartílico?`,
};

export const boxPlotContexts: { title: string; from: number; to: number; step: number }[] = [
    { title: 'Goles anotados por cada jugador esta temporada', from: 0, to: 20, step: 1 },
    { title: 'Puntajes en una prueba de 20 puntos', from: 0, to: 20, step: 1 },
    { title: 'Minutos que tarda cada estudiante en llegar a la escuela', from: 0, to: 40, step: 2 },
    { title: 'Altura de las plántulas de girasol (cm)', from: 0, to: 40, step: 2 },
    { title: 'Puntajes en un examen de matemáticas', from: 0, to: 100, step: 5 },
    { title: 'Edades de las personas en una fiesta', from: 0, to: 100, step: 5 },
];
